import { HintWrapper } from './styled';

interface IHint {
  children: React.ReactNode;
}

export default function Hint({ children }: IHint) {
  return <HintWrapper>{children}</HintWrapper>;
}
